import { Injectable } from '@angular/core';
import { Province } from '../../onboarding/classes/province';

@Injectable()
export class ProvinceService {

  constructor() { }

  provinces: Province[] = [
    new Province('BC', "British Columbia"),
    new Province('AB', "Alberta"),
    new Province('SK', "Saskatchewan"),
    new Province('MB', "Manitoba"),
    new Province('ON', "Ontario"),
    new Province('QC', "Quebec"),
    new Province('NB', "New Brunswick"),
    new Province('NS', "Nova Scotia"),
    new Province('PE', "Prince Edward Island"),
    new Province('NL', "Newfoundland"),
    new Province('YT', "Yukon"),
    new Province('NT', "Northwest Territories"),
    new Province('NU', "Nunavut")
  ];

  getProvinces(){
    return this.provinces;
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/province.service.ts